module.exports = __webpack_public_path__ + "img/Transpordiamet_vapp_varviline_est.26d08bcc.svg";